import React from 'react';

/**
 * Shared ambient gradient + grid overlay used behind the Landing, Login, and
 * Signup pages. Extracted to avoid duplicating this markup across pages.
 */
const PageBackground: React.FC = () => (
  <>
    <div className="fixed inset-0 z-0 opacity-50 pointer-events-none">
      <div
        className="absolute top-[-20%] left-[-10%] w-[70vw] h-[70vw] bg-gradient-to-br from-pink-200/40 via-rose-200/40 to-fuchsia-200/40 blur-[120px] rounded-full animate-pulse"
        style={{ animationDuration: '10s' }}
      />
      <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] bg-gradient-to-tl from-rose-200/40 via-pink-200/40 to-purple-200/40 blur-[100px] rounded-full" />
    </div>

    <div
      className="fixed inset-0 z-0 pointer-events-none"
      style={{
        backgroundImage:
          'linear-gradient(rgba(0,0,0,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)',
        backgroundSize: '4rem 4rem',
      }}
    />
  </>
);

export default PageBackground;
